var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm.894 3.857h3.402l2.415 3.433 2.932-3.433h1.071l-3.519 4.12 4.34 6.166h-3.401L11.33 13.16 7.93 17.143H6.857l3.99-4.67-3.953-5.616Zm1.64.857 6.047 8.572h1.313L9.848 7.714H8.535Z",
    fill: "currentColor"
  })));
};
export { SvgTwitter as ReactComponent };
export default __webpack_public_path__ + "3375335c45b9209cb2ed8a5084cbdf1e.svg";